import AttackTable from './AttackTable';

export default AttackTable;
export { AttackTable };
